import ko from '@tko/build.knockout';
import templateMarkup from 'raw-loader!./schedulegrid-widget.html';
import DataProvider from "../../../app/data-framework/data-provider";

  function SchedulegridWidget(params) {
      var self = this;
      this.observableOptions = params.observableOptions;
      this.observableData = params.observableData;
      self.panelTemplate = params.panelTemplate;
      self.widgetSignals = params.widgetSignals;
      self.dataProvider = DataProvider.getInstance();

      //trigger load
      if (params.observableParamsList && params.observableParamsList[0])
          params.observableParamsList[0].valueHasMutated();

      //trigger load on add modal close
      $("#ScheduleModal").on('hidden.bs.modal', function (e) {

          params.observableParamsList[0].valueHasMutated();

      });

      var savedFilters = self.observableOptions().filter;

      self.subscriptions = [];
      //self.subscriptions.push(self.observableOptions.subscribe(function () { self.OptionsUpdated(); }));

      self.nameFilter = ko.observable("Search");

      var defmodifier = "all";

      if (savedFilters && savedFilters.modifier)
          defmodifier = savedFilters.modifier;

      self.modifier = ko.observable(defmodifier);

      self.subscriptions.push(self.modifier.subscribe(function(newValue) {

          var options = self.observableOptions();

          if (!options.filter) {
              options.filter = {};
          }

          options.filter.modifier = newValue;

          if (self.widgetSignals)
              self.widgetSignals().dataRequested.dispatch();

          self.observableOptions(options);


      }));


      self.clearTextVisible = ko.observable(false);

      self.clearText = function () {
          self.nameFilter('');
          self.clearTextVisible(false);
      };

      if (savedFilters && savedFilters.search && (savedFilters.search != "Search")) {
          self.nameFilter(savedFilters.search);
          self.clearTextVisible(true);
      }

      self.subscriptions.push(self.nameFilter.subscribe(function (newValue) {
          self.clearTextVisible(newValue != "Search");

          var options = self.observableOptions();

          if (!options.filter) {
              options.filter = {};
          }

          options.filter.search = newValue == "Search" ? "" : newValue;

          if (self.widgetSignals)
              self.widgetSignals().dataRequested.dispatch();

          self.observableOptions(options);
      }));

      self.searchFontColor = ko.observable("#888");
      self.searchFontStyle = ko.observable("italic");

      self.inputFocus = function (a, b) {
          if (self.nameFilter() == "Search") {
              self.nameFilter('');
              self.searchFontColor("#000");
              self.searchFontStyle("normal");
          }
      };
      self.inputBlur = function (a, b) {
          if (self.nameFilter() == "") {
              self.nameFilter('Search');
              self.searchFontColor("#888");
              self.searchFontStyle("italic");
          }
      };


      self.RefreshData();

      self.subscriptions.push(self.observableData.subscribe(function () { self.DataUpdated(); }));
  }

  SchedulegridWidget.prototype.RefreshData = function () {
        var self = this;

        var data = self.observableData();

        if (!$.isEmptyObject(data)) {
        }
    };

    SchedulegridWidget.prototype.DataUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    SchedulegridWidget.prototype.OptionsUpdated = function () {
        var self = this;
        self.RefreshData();
    };
  // This runs when the component is torn down. Put here any logic necessary to clean up,
  // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    SchedulegridWidget.prototype.dispose = function () {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };
  
  export default { viewModel: SchedulegridWidget, template: templateMarkup };
